var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.001,
    height: 20,
    viewBox: "0 0 20.001 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12185",
    "data-name": "Group 12185",
    transform: "translate(0 -0.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49630",
    "data-name": "Path 49630",
    d: "M15.834,92.483a.833.833,0,0,0-.833.833v6.667a.834.834,0,0,1-.833.833H2.5a.834.834,0,0,1-.833-.833V88.316a.834.834,0,0,1,.833-.833H9.167a.833.833,0,0,0,0-1.667H2.5a2.5,2.5,0,0,0-2.5,2.5V99.983a2.5,2.5,0,0,0,2.5,2.5H14.167a2.5,2.5,0,0,0,2.5-2.5V93.316a.833.833,0,0,0-.833-.833Zm0,0",
    transform: "translate(0 -81.982)",
    fill: "#ff8d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49631",
    "data-name": "Path 49631",
    d: "M182.52,74.856a.422.422,0,0,0-.114.212l-.589,2.947a.416.416,0,0,0,.409.5.4.4,0,0,0,.082-.008l2.946-.589a.415.415,0,0,0,.213-.114l6.594-6.594-2.946-2.946Zm0,0",
    transform: "translate(-174.706 -65.114)",
    fill: "#ff8d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49632",
    "data-name": "Path 49632",
    d: "M395.545,1.11a2.085,2.085,0,0,0-2.946,0l-1.153,1.153,2.946,2.946,1.153-1.153a2.083,2.083,0,0,0,0-2.946Zm0,0",
    transform: "translate(-376.154 0)",
    fill: "#ff8d00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.a970d9f3bb48c7016119e81009b3b7b2.svg";
export { ForwardRef as ReactComponent };